////////////////////////////////////////////////////////////////////////////////////
// Dynamic Filter Count and Applied Filters Display for Careers Filtering
////////////////////////////////////////////////////////////////////////////////////
// This code manages the careers filtering system, including:
// - Updating filter dropdown counts dynamically based on selected filters.
// - Displaying selected filters in an "applied filters" section with options
//   to remove individual filters.
//
// Features:
// - Dropdown filter counts are updated in real-time as users select checkboxes.
// - Applied filters are listed dynamically with a remove button for each.
// - Dropdown arrows toggle based on expansion/collapse state.
//
// Dependencies: The HTML structure requires classes `.js-dropdown-toggle`,
// `.js-checkbox-item`, `.js-applied-filters`, and `.js-remove-filter-item`.
////////////////////////////////////////////////////////////////////////////////////

// Toggle for enabling or disabling debug logging
const DEBUG_MODE = false; // Set to `false` in production to disable console logs
const showmore = true;

let isFilterChanged = false; // Track if any filter has changed

document.addEventListener('DOMContentLoaded', function () {
  // Select all dropdown buttons, checkbox inputs, and the applied filters container
  const dropdownButtons = document.querySelectorAll('.js-dropdown-toggle');
  const checkboxes = document.querySelectorAll('.js-checkbox-item');
  const appliedFiltersContainer = document.querySelector('.js-applied-filters'); // For applied filters section
  //const textSearchInput = document.querySelector('.js-text-search'); // Text search input
  const sortDropdownButton = document.querySelector('.js-sort-toggle'); // Sort dropdown buttons

  // const 

  // Prevent dropdown from closing when interacting with checkboxes or labels
  const dropdownMenus = document.querySelectorAll('.js-dropdown-menu');
  dropdownMenus.forEach(function (dropdownMenu) {
    dropdownMenu.addEventListener('click', function (event) {
      event.stopPropagation(); // Prevent dropdown from closing when interacting inside
    });
  });

  // Mark filters as changed when any checkbox or text input is interacted with
  checkboxes.forEach(checkbox => checkbox.addEventListener('change', markFilterAsChanged));
  
  //if (textSearchInput) {
  //  textSearchInput.addEventListener('input', markFilterAsChanged);
  //}

  // Update filter count and applied filters section when a checkbox is changed
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      updateFilterCountAndAppliedFilters();
    });
  });

  // Sort Dropdown
  if (sortDropdownButton) {
    sortDropdownButton.addEventListener('click', function (event) {
      event.stopPropagation(); // Prevent dropdown from closing when interacting inside
    });

    const sortCheckboxes = document.querySelectorAll('.js-sort-checkbox-item'); // Add a class to sort checkboxes
    const sortTextField = document.querySelector('.js-sort-order'); // Add a class to the text field you want to update

    sortCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        if (this.checked) {
          // Uncheck all other checkboxes in the sort group
          sortCheckboxes.forEach(otherCheckbox => {
            if (otherCheckbox !== this) {
              otherCheckbox.checked = false;
            }
          });
  
          // Update the value of the text field with the selected checkbox value
          if (sortTextField) {
            sortTextField.value = this.value; // Set the text field value to the selected checkbox value

            const label = this.closest('.form-check').querySelector('.js-form-check-label').innerText;

            sortDropdownButton.innerHTML = 'Sort By <span>' + label + '</span>';
  
            // Manually trigger the change event on the text field
            const event = new Event('change', { bubbles: true });
            sortTextField.dispatchEvent(event);
          }
        } else {
          // Check if no checkboxes are selected
          const anyChecked = Array.from(sortCheckboxes).some(cb => cb.checked);
          if (!anyChecked && sortTextField) {
            sortTextField.value = 'default'; // Set to default value

            sortDropdownButton.innerHTML = 'Sort By'; // Reset the dropdown text
  
            // Manually trigger the change event on the text field
            const event = new Event('change', { bubbles: true });
            sortTextField.dispatchEvent(event);
          }
        }
      });
    });
  }

  // Function to update filter counts and applied filters section
  function updateFilterCountAndAppliedFilters() {
    dropdownButtons.forEach(function (dropdownButton) {
      const filterName = dropdownButton.id.replace('dropdownFilterButton-', '');
      const dropdownMenu = document.querySelector(`#dropdownFilterButton-${filterName}`).closest('.dropdown');
      const selectedCount = dropdownMenu.querySelectorAll('.js-checkbox-item:checked').length;

      // Update the count in the dropdown button
      const placeholderText = dropdownButton.getAttribute('data-placeholder-text') || 'Filter';
      dropdownButton.innerHTML = `${placeholderText} ${selectedCount > 0 ? ` (${selectedCount})` : ''} <span class="js-arrow"><i class="icon icon-arrow-outward"></i></span>`;

    });

    // Update the applied filters section
    updateAppliedFiltersSection();
  }

  // Function to update applied filters section
  function updateAppliedFiltersSection() {
    const selectedFilters = [];
    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        const label = checkbox.closest('.form-check').querySelector('.js-form-check-label').innerText;
        const filterName = checkbox.name.replace('filter-', '').replace('[]', ''); // Get filter name without "filter-" and "[]"
        selectedFilters.push({ filterName, label, termId: checkbox.value });
      }
    });

    // Clear the current content
    appliedFiltersContainer.innerHTML = '';

    if (selectedFilters.length > 0) {
      // Create HTML structure similar to component-applied-filters.php
      const filtersDiv = document.createElement('div');
      filtersDiv.classList.add('applied-filters','position-relative','w-100');

      // Add headings
      filtersDiv.innerHTML = `
        <span class="d-inline-flex h5 mb-0 text-primary filter-subheading">Selected Filters:</span>
        <span class="d-none h5 fw-semibold mb-0 text-primary sticky-filter-subheading">Active Filters:</span>
        <ul class="list-inline d-inline-flex flex-wrap mb-0"></ul>
      `;

      const filtersList = filtersDiv.querySelector('ul');

      selectedFilters.forEach(filter => {
        const filterItem = document.createElement('li');
        filterItem.classList.add('list-inline-item', 'my-1');
        filterItem.innerHTML = `
          <button class="applied-filter js-applied-filter d-flex align-items-center justify-content-center fw-medium text-white text-decoration-none text-uppercase bg-mm-blue-400">
            ${filter.label}
            <span class="ms-3 d-flex justify-content-center align-items-center text-mm-blue-400 js-remove-filter-item"
              data-filter-name="${filter.filterName}" data-filter-value="${filter.termId}">
              <i class="icon icon-plus"></i>
            </span>
          </button>
        `;
        filtersList.appendChild(filterItem);

        // Add event listener for removing individual filter
        filterItem.querySelector('.js-remove-filter-item').addEventListener('click', function (event) {
          event.preventDefault();
          removeFilterItem(filter.filterName, filter.termId);
        });
      });

      appliedFiltersContainer.appendChild(filtersDiv);
    } else {
      appliedFiltersContainer.innerHTML = '<p>No filters applied.</p>';
      updateButtonVisibility();
    }
  }

  // Function to mark the filter as changed
  function markFilterAsChanged() {
    isFilterChanged = true;
    updateButtonVisibility();
  }

  // Function to remove individual filter item
  function removeFilterItem(filterName, filterValue) {
    // Find and uncheck the corresponding checkbox
    const checkbox = document.querySelector(`input[name="filter-${filterName}[]"][value="${filterValue}"]`);
    if (checkbox) {
      checkbox.checked = false;
      updateFilterCountAndAppliedFilters();
    }
  }

  // Toggle arrow direction (↑ or ↓) when dropdown is expanded/collapsed
  dropdownButtons.forEach(function (dropdownButton) {
    const arrow = dropdownButton.querySelector('.js-arrow');
    dropdownButton.addEventListener('click', function () {
      // Toggle the arrow direction based on dropdown expansion state
      const isExpanded = dropdownButton.getAttribute('aria-expanded') === 'true';
      arrow.innerHTML = isExpanded ? '<i class="icon icon-arrow-outward down"></i>' : '<i class="icon icon-arrow-outward"></i>'; // Switch between ↑ and ↓
    });
  });

  // Sort
});

// Function to scroll to the filter block
function scrollToFilterBlock() {
  const filterBlock = document.querySelector('.js-component-filter-block');
  if (filterBlock) {
    filterBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

// Function to manage the visibility of buttons based on selected filters, text input, or applied items
function updateButtonVisibility() {
  const applyFiltersButton = document.querySelector('.js-apply-filters');
  const clearFiltersButton = document.querySelector('.js-clear-filters');
  const checkboxes = document.querySelectorAll('.js-checkbox-item');
  const appliedFiltersContainer = document.querySelector('.js-applied-filters');
  //const textSearchInput = document.querySelector('.js-text-search');
  const sortByOrder = document.querySelector('.js-sort-order');

  const hasFilters = Array.from(checkboxes).some(checkbox => checkbox.checked);
  const hasAppliedFilters = appliedFiltersContainer.querySelectorAll('.js-remove-filter-item').length > 0;
  //const hasTextSearch = textSearchInput && textSearchInput.value.trim().length > 0;
  //const hasSortOrder = sortByOrder && sortByOrder.value.trim().length > 0;
  
  
  //if (isFilterChanged /*|| hasTextSearch*/ ) {
  //  applyFiltersButton.style.display = 'flex';
  //} else {
  //  applyFiltersButton.style.display = 'none';
  //}

  if (hasFilters || hasAppliedFilters /*|| hasTextSearch || hasSortOrder*/) {
    clearFiltersButton.style.display = 'flex';
  } else {
    clearFiltersButton.style.display = 'none';
  }

  // Log visibility for debugging
  if (DEBUG_MODE) {
    console.log("Button visibility updated - hasFilters:", hasFilters, "hasAppliedFilters:", hasAppliedFilters, /*"hasTextSearch:", hasTextSearch,*/ "isFilterChanged:", isFilterChanged /*, "hasSortOrder:", hasSortOrder*/);
    //console.log("Apply Filters Button:", applyFiltersButton.style.display, "Clear Filters Button:", clearFiltersButton.style.display);
  }

}

////////////////////////////////////////////////////////////////////////////////////
// Filter Button Visibility Management
////////////////////////////////////////////////////////////////////////////////////
// This code dynamically controls the visibility of the "Apply Filters" and
// "Clear Filters" buttons on the careers filter form based on the user's interactions.
//
// - "Apply Filters" appears when any filter is selected.
// - Only "Clear Filters" remains after filters are applied.
// - Both buttons are hidden if all filters are cleared.
//
// Dependencies: The HTML must include elements with classes `.js-apply-filters`,
// `.js-clear-filters`, `.js-checkbox-item`, and `.component-filter-block-form`.
////////////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function () {
  // Element references for filter buttons and text search
  const applyFiltersButton = document.querySelector('.js-apply-filters');
  const clearFiltersButton = document.querySelector('.js-clear-filters');
  const checkboxes = document.querySelectorAll('.js-checkbox-item');
  const filterForm = document.querySelector('.component-filter-block-form');
  const appliedFiltersContainer = document.querySelector('.js-applied-filters'); // Container for applied filters
  //const textSearchInput = document.querySelector('.js-text-search'); // Text search input
  //const sortOrder = document.querySelector('.js-sort-order'); // Sort order input

  // Initialize button visibility on page load
  updateButtonVisibility();

  // Event listener for form submission to apply filters
  filterForm.addEventListener('submit', function (event) {
    event.preventDefault(); // Prevent full page reload on form submission

    // Reset isFilterChanged flag and hide "Apply Filters" button after applying filters
    isFilterChanged = false;
    applyFiltersButton.style.display = 'none';
    clearFiltersButton.style.display = 'flex';
  });

  // Event listener for checkbox state change to toggle button visibility
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function(){
      filterPosts();
      updateButtonVisibility();
    });
  });

  // Event listener for text input changes to toggle button visibility
  // textSearchInput.addEventListener('input', updateButtonVisibility);

  // Event listener for the "Enter" key in the text search field to submit the form
  /*
  textSearchInput.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default form submission if Enter is pressed
      filterForm.dispatchEvent(new Event('submit')); // Trigger form submit
    }
  });
  */

  /*
  .addEventListener('change', updateButtonVisibility);
  sortOrder.addEventListener('change', function() {
    filterForm.dispatchEvent(new Event('submit')); // Trigger form submit
  });
  */

  // Clear filters functionality
  clearFiltersButton.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent any default button behavior

    // Uncheck all checkboxes, reset form, and clear the search field
    checkboxes.forEach(checkbox => (checkbox.checked = false));
    filterForm.reset(); 
    /*
    if (textSearchInput) {
      textSearchInput.value = ''; // Clear the search field
    }
    */

    /*
    if (sortOrder) {
      document.querySelectorAll('.js-sort-checkbox-item').forEach(checkbox => (checkbox.checked = false));
      sortOrder.setAttribute('value', ''); // Reset the sort order
      sortOrder.value = ''; // Reset the sort order
      document.querySelector('.js-sort-toggle').innerHTML = 'Sort By'; // Reset the dropdown text
    }
    */

    // Reset isFilterChanged flag, hide buttons after clearing filters
    isFilterChanged = false;
    applyFiltersButton.style.display = 'none';
    clearFiltersButton.style.display = 'none';

    // Optionally trigger AJAX to reload default results
    // filterPosts(1); // Reload the default results
  });

  // Listen for clicks on .js-remove-filter-item and perform AJAX filtering
  appliedFiltersContainer.addEventListener('click', function (event) {
    if (event.target.classList.contains('js-remove-filter-item')) {
      event.preventDefault();

      const filterName = event.target.getAttribute('data-filter-name');
      const filterValue = event.target.getAttribute('data-filter-value');

      removeFilterItem(filterName, filterValue);

      // Delay the visibility update to allow the DOM to reflect changes
      setTimeout(updateButtonVisibility, 500);
    }
  });
});

////////////////////////////////////////////////////////////////////////////////////
// AJAX-Driven Careers Filtering with Dynamic UI Updates
////////////////////////////////////////////////////////////////////////////////////
// This code handles the AJAX-powered filtering system for the Careers section:
// - Submits filter selections asynchronously to fetch filtered results without
//   reloading the page.
// - Updates the careers grid, pagination, applied filters, and filter count display
//   based on the AJAX response.
// - Includes a clear filters function that resets selections and refreshes the results.
//
// Features:
// - Dynamically updates applied filters, filter counts, and pagination with each change.
// - Updates browser history to reflect filter selections for easy sharing of filter states.
//
// Dependencies: Requires classes `.js-dropdown-toggle`, `.js-applied-filters`,
// `.js-posts-cards`, `.js-clear-filters`, and `.component-filter-block-form`.
////////////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function () {
  // Element references for filter form, pagination, and results container
  const filterForm = document.querySelector('.component-filter-block-form');
  const filterFormPostType = filterForm ? filterForm.getAttribute('data-post-type') : 'post';
  const paginationContainer = document.querySelector('.section-pagination');
  const postsGrid = document.querySelector('.js-posts-cards');
  const appliedFiltersContainer = document.querySelector('.js-applied-filters'); // For applied filters
  const paginationInfo = document.querySelector('.js-pagination-info'); // For pagination info
  const filterButtons = document.querySelectorAll('.js-dropdown-toggle'); // For updating filter counts

  if (DEBUG_MODE) {
    console.log('Filter Form:', filterForm);
    console.log('Filter Form Post Type:', filterFormPostType);
    console.log('Pagination Container:', paginationContainer);
    console.log('Cards Grid:', postsGrid);
  }

  // Handle the AJAX request for filtering careers
  //function filterPosts(page = 1) {
  window.filterPosts = function(page = 1, showmorelink = false){
  const formData = new FormData(filterForm); // Serialise form data
  const loadmoreformData = new FormData(filterForm);
  loadmoreformData.set('paged', page);
  formData.set('paged', page); // Set the current page number in the form

  // Convert form data to a query string
  const queryString = new URLSearchParams(formData).toString();
  

  // Conditional logging based on DEBUG_MODE
  if (DEBUG_MODE) {
    console.log('Form Data:', queryString); // DEBUG: Log form data before sending
  }

  // Send the AJAX request
  const pagination_loadmore = (showmorelink)?'showmore=1':'';
  fetch(`${window.location.origin}/wp-admin/admin-ajax.php?action=nous_filter_${filterFormPostType}&${queryString}`, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => response.json()) // Parse the response as JSON
    .then(data => {
      if (DEBUG_MODE) {
        console.log('AJAX Response:', data); // DEBUG: Log the entire response
      }

      // Check if the AJAX request was successful
      if (data.success) {
        // Update the posts grid with the returned content
        if (postsGrid && data.data.cards_html) {
            
          if(!showmorelink){
            postsGrid.innerHTML = data.data.cards_html;
          }else{
            postsGrid.insertAdjacentHTML('beforeend', data.data.cards_html);
          }
          
        } else if (postsGrid) {
          postsGrid.innerHTML = '<p>No posts found.</p>'; // Show 'No posts found' if no results
        }

        // Update pagination info (e.g., "Showing 1-2 of 10 results")
        if (paginationInfo && data.data.pagination_info_html !== '') {
          paginationInfo.innerHTML = data.data.pagination_info_html;
        } else if (paginationInfo) {
          paginationInfo.innerHTML = ''; // Clear pagination info if no results
        }

        // Update pagination controls (e.g., previous/next buttons)
        if (paginationContainer && data.data.pagination_html !== '') {
          paginationContainer.innerHTML = data.data.pagination_html;

          // Rebind pagination events after pagination controls are updated
          bindPaginationEvents();
        } else if (paginationContainer) {
          paginationContainer.innerHTML = ''; // Clear pagination if no results
        }

        // Dynamically update the applied filters section
        if (appliedFiltersContainer && data.data.applied_filters_html) {
          appliedFiltersContainer.innerHTML = data.data.applied_filters_html;
        } else if (DEBUG_MODE) {
          console.log('No applied filters in response'); // DEBUG: Log missing applied filters
        }

        // Update filter counts for each taxonomy based on AJAX response data
        if (data.data.filter_counts) {
          Object.keys(data.data.filter_counts).forEach(function (taxonomy) {
            updateFilterCount(taxonomy); // Update counts for each filter taxonomy
          });
        }

        updateButtonVisibility();
        setTimeout(function(){ lenis.resize(); },200);

        // Update the browser URL to reflect the current filter state (for sharing)
        if(!showmorelink){
          const updatedUrl = `?${queryString}`;
          history.pushState(null, '', updatedUrl);
        }

      } else {
        // Handle the case where no results are returned
        console.error('Failed to retrieve filtered posts data.');
        if (postsGrid) {
          postsGrid.innerHTML = '<p>No posts found.</p>'; // Show 'No careers found' message
        }
        if (paginationInfo) {
          paginationInfo.innerHTML = ''; // Clear pagination info
        }
        if (paginationContainer) {
          paginationContainer.innerHTML = ''; // Clear pagination
        }

        // Reset all filter counts to zero if the request fails
        filterButtons.forEach(button => {
          const placeholderText = button.getAttribute('data-placeholder-text') || button.textContent.split('(')[0].trim();
          button.innerHTML = `${placeholderText} <span class="js-arrow"><i class="icon icon-arrow-outward"></i></span>`;
        });

        // TODO Update/Reset Sort
      }
    })
    .catch(error => {
      // Handle any AJAX errors
      console.error('Error:', error);

      // Reset all filter counts to zero if there is an AJAX error
      filterButtons.forEach(button => {
        const placeholderText = button.getAttribute('data-placeholder-text') || button.textContent.split('(')[0].trim();
        button.innerHTML = `${placeholderText} <span class="js-arrow"><i class="icon icon-arrow-outward"></i></span>`;
      });
    });
  }

  // Remove a specific filter item, update the URL, and re-fetch the results
  function removeFilterItem(filterName, filterValue) {
    // Get the current query string and URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Find the corresponding filter parameter in the URL and remove the filter value
    if (urlParams.has(`filter-${filterName}`)) {
      let filterValues = urlParams.getAll(`filter-${filterName}`);

      // Remove the specific filter value from the parameter
      filterValues = filterValues.filter(value => value !== filterValue);

      // Update the URL query string with the remaining filter values or remove the parameter if empty
      if (filterValues.length > 0) {
        urlParams.set(`filter-${filterName}`, filterValues.join(',')); // Set the remaining filters
      } else {
        urlParams.delete(`filter-${filterName}`); // Remove the parameter completely if no filters remain
      }
    }

    // Uncheck the corresponding checkbox in the dropdown
    const checkbox = document.querySelector(`input[name="filter-${filterName}[]"][value="${filterValue}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }

    // Reset pagination to page 1 when filters are removed
    urlParams.set('paged', 1);

    // Update the browser URL without reloading the page
    const updatedUrl = `${window.location.pathname}?${urlParams.toString()}`;
    history.pushState(null, '', updatedUrl);

    // Re-fetch the filtered careers after the filter is removed, starting from page 1
    filterPosts(1);

    // Update the filter count for the relevant dropdown button
    updateFilterCount(filterName);

    // Ensure button visibility is updated after filter removal
    setTimeout(updateButtonVisibility, 500);
  }

  // Update the filter count for a specific filter group
  function updateFilterCount(filterName) {
    const dropdownButton = document.getElementById(`dropdownFilterButton-${filterName}`);

    if (dropdownButton) {
      // Get all checkboxes in the specific filter group
      const checkboxes = document.querySelectorAll(`input[name="filter-${filterName}[]"]`);
      const checkedItems = document.querySelectorAll(`input[name="filter-${filterName}[]"]:checked`);
      const count = checkedItems.length;

      // Get the placeholder text from the dropdown button's data attribute
      const placeholderText = dropdownButton.getAttribute('data-placeholder-text') || 'Filter';

      // Update the dropdown button text with the correct count for the specific filter group
      dropdownButton.innerHTML = `
        ${placeholderText}
        ${count > 0 ? ` (${count})` : ""}
        <span class="js-arrow"><i class="icon icon-arrow-outward"></i></span>
      `;
    }
  }

  // Initialise filter counts based on URL parameters
  function initialiseFilterCounts() {
    const urlParams = new URLSearchParams(window.location.search);

    filterButtons.forEach(function (dropdownButton) {
      const filterName = dropdownButton.id.replace('dropdownFilterButton-', '');

      // Get the count of selected filters from URL parameters for this specific filter group
      const selectedFilters = urlParams.getAll(`filter-${filterName}[]`);
      const count = selectedFilters.length;

      // Set the correct placeholder text with the count for each dropdown
      const placeholderText = dropdownButton.getAttribute('data-placeholder-text') || 'Filter';
      dropdownButton.innerHTML = `${placeholderText} (${count}) <span class="js-arrow"><i class="icon icon-arrow-outward"></i></span>`;
    });
  }

  // Initialise filter counts on page load based on query string parameters
  // initialiseFilterCounts();

  // Remove filter item when clicking the remove filter button
  document.addEventListener('click', function (event) {
    if (event.target.closest('.js-remove-filter-item')) {
      event.preventDefault();

      // Get the filter name and value from data attributes
      const filterName = event.target.closest('.js-remove-filter-item').getAttribute('data-filter-name');
      const filterValue = event.target.closest('.js-remove-filter-item').getAttribute('data-filter-value');

      // Call the function to remove the filter
      removeFilterItem(filterName, filterValue);
    }
  });

  // Clear all filters and reset the page to default state
  function clearFilters() {
    // Remove query string items by resetting the URL without reloading the page
    const baseUrl = window.location.origin + window.location.pathname;
    history.pushState(null, '', baseUrl);

    // Reset the form fields
    filterForm.reset(); // Reset all inputs to their initial values (unchecked checkboxes, cleared text)

    // Uncheck all checkboxes manually (if form.reset() doesn't work for some cases)
    const checkboxes = document.querySelectorAll('.js-checkbox-item');
    checkboxes.forEach(function (checkbox) {
      checkbox.checked = false;
    });

    // Clear the search input field
    const searchField = document.querySelector('#filter-search');
    if (searchField) {
      searchField.value = '';
    }

    // Reset filter dropdown counts and placeholder text to initial state
    const dropdownButtons = document.querySelectorAll('.js-dropdown-toggle');
    dropdownButtons.forEach(function (dropdownButton) {
      const taxonomy = dropdownButton.id.replace('dropdownFilterButton-', ''); // Extract taxonomy from button ID

      // Find the corresponding placeholder text from the HTML (set in PHP)
      const placeholderText = dropdownButton.getAttribute('data-placeholder-text');

      // If placeholderText exists, reset to that, otherwise default to 'Filter'
      dropdownButton.innerHTML = `${placeholderText || 'Filter'} <span class="js-arrow"><i class="icon icon-arrow-outward"></i></span>`;
    });

    // Clear the applied filters section (if it exists)
    if (appliedFiltersContainer) {
      appliedFiltersContainer.innerHTML = ''; // Clear the applied filters
    }

    // Trigger an AJAX request to load the default career cards and reset pagination
    filterPosts(1); // Pass page 1 to reset pagination to the default state
  }

  // Bind the clear filters button to the clearFilters function
  const clearFiltersButton = document.querySelector('.js-clear-filters');
  if (clearFiltersButton) {
    clearFiltersButton.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent the button from submitting the form or reloading the page
      clearFilters(); // Call the clearFilters function
    });
  }

  // Bind pagination link click events
  function bindPaginationEvents() {
    if (paginationContainer) {
      const paginationLinks = paginationContainer.querySelectorAll('a');
      const loadmorelink = paginationContainer.querySelectorAll('a.loadmore');
      paginationLinks.forEach(link => {
        link.addEventListener('click', function (event) {
          event.preventDefault(); // Prevent default link behavior
          const page = new URL(link.href).searchParams.get('paged'); // Extract the page number
          if(loadmorelink){
            filterPosts(page, 1);
          }else{
            filterPosts(page); // Fetch the content for the selected page
          }
          // Scroll to the filter block after AJAX is complete
          if(!showmore){  
            setTimeout(scrollToFilterBlock, 300);
          }
        
        });
      });
    }
  }

  // Handle form submission to apply filters and fetch results dynamically
  filterForm.addEventListener('submit', function (event) {
    event.preventDefault(); // Prevent full page reload on form submission
    filterPosts(); // Call filterPosts with page 1 by default
  });

  // Bind pagination links on initial page load
  bindPaginationEvents();

  // Load the initial page based on the URL if there's a paged parameter
  const urlParams = new URLSearchParams(window.location.search);
  const initialPage = urlParams.get('paged') || 1;
  if (initialPage > 1) {
    filterPosts(initialPage); // Load the correct page on initial load
  }
});
